<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>Transaction Report</span>
    </div>
  
    <el-row :gutter="10" class="search-area">
      <el-col  :xs="24" :sm="24" :md="12" :lg="12">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              format="dd MMMM yyyy"
              value-format="yyyy-MM-dd"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="getTransaction()">
            </el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" style="text-align:right">
        <el-link class="el-button el-button--success" icon="el-icon-download" :underline="false" :href="downloadExcel()" :disabled="checkReport()">Export</el-link>
      </el-col>
    </el-row>
    <el-row>
      <summary-view :data="summaryData" viewSize="small"></summary-view>
    </el-row>
    <el-row class="transaction-report">
      <el-col>
        <data-tables v-loading="loading" :data="tableData" border :page-size="10" :pagination-props="{ background: true, pageSizes: [5, 10, 20, 50, 100] }">
          <el-table-column prop="date" label="Date" width="160" fixed header-align="center" align="center">
            <template slot-scope="scope">
              {{ dateFormat(scope.row.date) }}
            </template>
          </el-table-column>
          <el-table-column prop="username" fixed label="User" header-align="center" align="center" width="150"></el-table-column>
          <el-table-column prop="transactionref" fixed label="ACtions" header-align="center" align="center" width="100">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="scope.row.status === 'pending'" @click="transactionCancel(scope.row.transactionref, scope.row.currency)">Cancel</el-button>
              <el-button size="mini" type="success" v-if="scope.row.status === 'success'" @click="transactionRefund(scope.row.transactionref, scope.row.currency)">Refund</el-button>
              <el-button size="mini" type="warning" v-if="scope.row.status === 'refund'" @click="detailRefund(scope.row.transactionref)">Detail</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="Currency" header-align="center" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.currency.toUpperCase()}}
            </template>
          </el-table-column>
          <el-table-column prop="cardnetwork" label="Card Network" header-align="center" align="center" width="120"></el-table-column>
          <el-table-column prop="cardtype" label="Card Type" header-align="center" align="center"  width="100"></el-table-column>
          <el-table-column prop="volume" label="Volume" header-align="center" align="center"  width="100"></el-table-column>
          <el-table-column prop="transaccharge" label="Gateway Fee" header-align="center" align="center" width="130"></el-table-column>
          <el-table-column prop="cardcharge" label="Acquire Fee" header-align="center" align="center" width="120"></el-table-column>
          <el-table-column prop="othercharge" label="Other Charge" header-align="center" align="center"  width="105"></el-table-column>
          <el-table-column prop="settlefund" label="Settle fund" header-align="center" align="center"  width="100"></el-table-column>
          <el-table-column prop="3dsecure" label="3D Secure" header-align="center" align="center"  width="100"></el-table-column>
          <el-table-column prop="channel" label="Channel" header-align="center" align="center"  width="100"></el-table-column>
          <el-table-column prop="status" label="Status" header-align="center" align="center" width="100">
            <template slot-scope="scope">
              <el-tag :type="btnStatus[scope.row.status]">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="transactionref" label="Transaction Ref" header-align="center" align="center" width="250"></el-table-column>
          <el-table-column prop="customerref" label="Customer Ref" header-align="center" align="center" width="250"></el-table-column>
          <el-table-column prop="remark" label="Remark" header-align="center" align="center" width="250"></el-table-column>
        </data-tables>

      </el-col>
    </el-row>
    <el-dialog title="Transaction Refund" :visible.sync="dialogRefund" width="40%">
      <el-form :model="refundForm">
        <el-form-item label="Transaction Ref." :label-width="formLabelWidth">
          <el-input v-model="refundForm.transactionRef" autocomplete="off" readonly="true" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="Currency" :label-width="formLabelWidth">
          <el-input v-model="refundForm.currency" autocomplete="off" readonly="true" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="Amount" :label-width="formLabelWidth">
          <el-input v-model="refundForm.amount" autocomplete="off" type="number"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRefund = false">Cancel</el-button>
        <el-button type="primary" @click="sendRefund()" :loading="btnSendRefundLoading">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog  title="Refund Detail"  :visible.sync="dialogDetail"  width="30%">
      <h3><span>Original Amount: <b>{{ refundDetail.originalamount + " " + refundDetail.currency}}</b></span></h3>
      <h3><span>Refund Amount: <b>{{ refundDetail.refundamount + " " + refundDetail.currency}}</b></span></h3>
      <h3><span>Refund Date: <b>{{ refundDetail.refunddate}}</b></span></h3>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDetail = false">Close</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>



import transaction from "@/api/transaction";
import utility from "@/components/utility";
import store from "@/store";
import summaryView from "@/components/summaryui/transaction";
export default {
  components:{
    summaryView
  },
  data() {
    return {
      tableData: [],
      dateRange: [utility.currentDate('YYYY-MM-DD'), utility.currentDate('YYYY-MM-DD')],
      baseurl: process.env.VUE_APP_SERVER_BASE_API || '',
      token: store.getters.auth || '',
      loading: true,
      summaryData: {},
      btnStatus:{
        "pending" : "",
        "cancel": "info",
        "refund": "warning",
        "success": "success",
        "failed": "danger"
      },
      formLabelWidth: '120px',
      dialogRefund: false,
      dialogDetail: false,
      refundForm:{
        "transactionRef": "",
        "currency":"",
        "amount":0,
        "reason":"1"
      },
      btnSendRefundLoading: false,
      refundDetail:{
        "originalamount": 0,
        "refundamount": 0,
        "refunddate": "",
        "currency": ""
      }
    };
  },
  methods: {
    getTransaction() {
      this.loading = true
      const formData = {
        startdate: this.dateRange[0],
        enddate: this.dateRange[1]
      };
      transaction.getTransaction(formData).then(res => {
        if (res && res["result"]) {
          //console.log(res["data"]);
          this.tableData = res["data"];
          this.getSummary()
          this.loading = false
        }
      });
    },
    getSummary(){
      const formData = {
        startdate: this.dateRange[0],
        enddate: this.dateRange[1]
      };
      transaction.getSummary(formData).then( res => {
         if (res && res["result"]) {
           this.summaryData = res['data']
         }
      })
    },
    dateFormat(date){
      return utility.dateFormat(date, 'DD/MM/YYYY HH:mm')
    },
    checkReport(){
      if(this.tableData.length == 0){
        return true
      }
      return false
    },
    downloadExcel(){
      if(this.tableData.length == 0){
        return '#'
      }
      return this.baseurl+'/api/transaction/excel?startdate='+this.dateRange[0]+'&enddate='+this.dateRange[1]+'&token='+this.token
    },
    transactionCancel(transref, currency){
      this.$confirm('Are you sure you want to cancel this transaction?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {

        const formData = {
          transactionRef: transref,
          currency: currency,
          reason: 1
        };

        transaction.Cancel(formData).then( res => {
          if (res && res["result"]) {
            this.getTransaction();
          }
        });

      });


    },

    sendRefund(){
      this.btnSendRefundLoading = true;
      transaction.Refund(this.refundForm).then( res => {
          if (res && res["result"]) {
            this.dialogRefund = false;
            this.btnSendRefundLoading = false;
            this.getTransaction();
          }
        });
    },
    transactionRefund(transref, currency){
      this.dialogRefund = true;
      this.refundForm.transactionRef = transref;
      this.refundForm.currency = currency;

    },
    detailRefund(transref){
      transaction.getRecord({ transactionRef: transref}).then(res => {
        if (res && res["result"]) {
          let data = res["data"];
          this.refundDetail.originalamount = data.originalamount;
          this.refundDetail.refundamount = data.refundamount;
          this.refundDetail.refunddate = data.refunddate;
          this.refundDetail.currency = data.currency;
          this.dialogDetail = true;
        }
      });
    }


  },
  created() {
    this.getTransaction();
  }
};
</script>

<style lang="scss">
.search-area {
  margin-bottom: 16px;

  .el-button{
    margin-left: 20px;
  }

  .el-link.el-link--default {
      color: #ffffff;
  }
  .el-date-editor .el-range-separator {
    width: 8%;
  }
}
 
 .transaction-report{
   .sc-table{
     border: 1px solid #EBEEF5;
   }
   .el-table th.is-leaf{
     background-color: rgb(121, 136, 150);
     color: #ffffff;
   }
   .el-table th.is-leaf, .el-table td {
      border-bottom: 1px solid #EBEEF5;
      border-right: 1px solid #EBEEF5;
    }

    .pagination-bar{
      margin-top: 10px;
    }
 }
 
</style>
